import { FindAssignmentsByGuestAndDateQuery } from '../generated/graphql';

type AssignmentArray = NonNullable<
  FindAssignmentsByGuestAndDateQuery['findAssignmentsByGuestAndDate']
>;
type Assignment = AssignmentArray[number];

export const getHotelName = (hotel: Assignment['hotel']): string => {
  if (!hotel) return 'Unknown Hotel';

  if (
    hotel.__typename === 'AmadeusHotel' ||
    hotel.__typename === 'ManualHotel'
  ) {
    return hotel.name || 'Unknown Hotel';
  }

  return 'Unknown Hotel';
};

export const getHotelLocation = (hotel: Assignment['hotel']): string => {
  if (!hotel) return 'Unknown Location';

  if (
    hotel.__typename === 'AmadeusHotel' ||
    hotel.__typename === 'ManualHotel'
  ) {
    const city = hotel.address?.city || 'Unknown City';
    const state = hotel.address?.state || 'Unknown State';
    return `${city}, ${state}`;
  }

  return 'Unknown Location';
};

export const formatBookingDateRange = (
  checkInDate: string,
  checkOutDate: string,
): string => {
  // This function is a placeholder for when we need to format date ranges
  // Currently we're using date-fns format directly, but this could be extended
  // to handle different formats or locales
  return `${checkInDate} - ${checkOutDate}`;
};
